<div class="sh-facet-summary">
    <p class="sh-facet-summary__title">{{chosenFiltersMsg}} ({{selectedFacets.length}})</p>
    <div class="sh-facet-summary__actions">
        <button class="sh-facet-summary__actions__action" (click)="onClear()" [disabled]="!selectedFacets.length">{{clearMsg}}</button>
    </div>
    <ul class="sh-tag-list summary-list">

        @for(facet of selectedFacets; track facet.facetLabel) {
            <li class="sh-tag--readonly -sh-small sh-tag-list__item">
                <span class="sh-tag__label" title="{{facet.facetLabel}}: {{facet.valueLabel}}">{{facet.facetLabel}}: {{facet.valueLabel}}</span>
                <button class="sh-tag__button" (click)="onRemove(facet)">
                    <svg class="sh-tag__icon" sh-icon [name]="'delete'" [size]="iconSize" aria-hidden="true"></svg>
                </button>
            </li>
        }

    </ul>
</div>
